export default __webpack_public_path__ + "static/media/imageForFilter2_648x448.aa646043.jpg";